import { connect, MapDispatchToProps } from 'react-redux';
import { beginCommentAwardBadgeFlow } from '../../../coreBadge/redux/actionCreators';
import { Props } from './AwardBadgeButton';

export type DispatchProps = Pick<Props, 'awardBadge'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  awardBadge: beginCommentAwardBadgeFlow,
};

export default connect(null, mapDispatchToProps);
